/* Progressive collection disclosure; Shopify remains responsible for catalog filtering. */
(() => {
  const mobile = window.matchMedia('(max-width: 749px)');
  function responsiveDetails(details) {
    details.open = !mobile.matches;
    mobile.addEventListener('change', event => { details.open = !event.matches; });
  }
  function enhanceCollection() {
    const main = document.querySelector('#MainContent[data-template^="collection"]');
    if (!main) return;
    const intro = main.querySelector('.shopify-section:has(h1) rte-formatter');
    if (intro && !intro.querySelector('.tg-collection-description')) {
      const first = intro.querySelector(':scope > p');
      if (first && first.nextElementSibling) {
        const details = document.createElement('details');
        details.className = 'tg-collection-description';
        const summary = document.createElement('summary');
        summary.textContent = 'Materials & installation guide';
        details.append(summary);
        while (first.nextSibling) details.append(first.nextSibling);
        intro.append(details);
        responsiveDetails(details);
      }
    }
    main.querySelectorAll('.tg-size-filter:not([data-tg-disclosure])').forEach(section => {
      const active = section.querySelector('[aria-current="true"]');
      const details = document.createElement('details');
      details.className = 'tg-fit-disclosure';
      const summary = document.createElement('summary');
      summary.textContent = active ? 'Size: ' + active.textContent.trim() : 'Filter by fixture size';
      details.append(summary);
      while (section.firstChild) details.append(section.firstChild);
      section.append(details);
      section.dataset.tgDisclosure = 'true';
      responsiveDetails(details);
      if (active) details.open = true;
    });
    const shortcuts = main.querySelector('.tianguang-collection-shortcuts');
    if (shortcuts && location.pathname.startsWith('/collections/wall-lamps')) {
      // These collection links already appear in the current collection introduction.
      const destinations = new Map([
        ['Plug-in', '/collections/plug-in-wall-sconces'],
        ['Alabaster', '/collections/alabaster-wall-sconces']
      ]);
      shortcuts.querySelectorAll('a').forEach(link => {
        const path = destinations.get(link.textContent.trim());
        if (path) link.href = path;
      });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', enhanceCollection, { once: true });
  else enhanceCollection();
  document.addEventListener('shopify:section:load', enhanceCollection);
  // Native collection AJAX may replace a complete section after a filter changes.
  const main = document.querySelector('#MainContent[data-template^="collection"]');
  if (main) new MutationObserver(records => {
    if (records.some(record => [...record.addedNodes].some(node => node instanceof Element &&
      (node.matches('.tg-size-filter,.shopify-section') || node.querySelector('.tg-size-filter:not([data-tg-disclosure])'))))) {
      enhanceCollection();
    }
  }).observe(main, { childList: true, subtree: true });
})();
